<template>
  <div class="register-container">
    <h2>用户注册</h2>
    <el-form ref="form" @submit.prevent="register" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="用户名" prop="username">
        <el-input v-model="form.username" required></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile">
        <el-input v-model="form.mobile" required></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input type="password" v-model="form.password" required></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" native-type="submit">注册</el-button>
      </el-form-item>
    </el-form>
    <p v-if="error" class="error">{{ error }}</p>
    <p v-if="success" class="success">
      注册成功!
    </p>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      form: {
        username: '',
        mobile: '',
        password: ''
      },
      error: '',
      success: '',
      countdown: 5,
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    async register() {
      try {
        await this.$refs.form.validate(); // 验证表单
        const response = await axios.post('/api/register', {
          username: this.form.username,
          mobile: this.form.mobile,
          password: this.form.password
        });
        console.log(response.data);
        this.error = '';
        this.form.username = '';
        this.form.mobile = '';
        this.form.password = '';
        this.success = `注册成功`;
        // 倒计时5秒钟后跳转到登录页面
        //const interval = setInterval(() => {
        //  this.countdown--;
        //  this.success = `注册成功, ${this.countdown}秒后跳转到登录页面`;
        //  if (this.countdown <= 0) {
        //    clearInterval(interval);
        //    this.$router.push({ name: 'LoginPage' });
        //  }
       // }, 1000);
      } catch (error) {
        if (error.response && error.response.status === 400) {
          this.error = '注册失败: ' + error.response.data.message;
        } else {
          this.error = '注册失败';
        }
        this.success = '';
        console.error(error);
      }
    }
  }
};
</script>

<style scoped>
.register-container {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;
}

.el-form-item {
  margin-bottom: 15px;
}

.error {
  color: red;
}

.success {
  color: green;
}

.red-countdown {
  color: red;
}
</style>
